/**
 * 🛰️ FRONTEND LOGGER: Operational telemetry for the Control Tower UI.
 * This logger standardizes error reporting and telemetry, 
 * preparing the platform for Sentry/Datadog integration.
 */

const getCorrelationId = () => {
  // In a real app, this could be pulled from a global state or header
  return "ui-" + Math.random().toString(36).substring(2, 9);
};

export const uiLogger = {
  info: (message: string, context?: any) => {
    if (process.env.NODE_ENV !== 'production') {
      console.log(`[UI INFO] [${getCorrelationId()}] ${message}`, context || "");
    }
  },

  warn: (message: string, context?: any) => {
    console.warn(`[UI WARN] [${getCorrelationId()}] ${message}`, context || "");
  },

  error: (message: string, error?: any, context?: any) => {
    // 🛡️ SECURITY: Strip sensitive fields from error objects before logging
    const sanitizedError = error instanceof Error ? {
      name: error.name,
      message: error.message,
      stack: process.env.NODE_ENV === 'development' ? error.stack : undefined
    } : error;

    console.error(`[UI ERROR] [${getCorrelationId()}] ${message}`, {
      error: sanitizedError,
      ...context
    });
    
    // TODO: Send to remote monitoring (Sentry/LogRocket)
  }
};
